
export default function getIFrameId(state) {
  return state.iFrameId;
}
